



















































































































import { Component, Mixins } from "vue-property-decorator";
import Api from "@/api";
import FormErrorsMixin from "@/mixins/FormErrors";
import PartnerModal from "@/components/PartnerModal.vue";
import { IPartner } from "@/interface";
import { AxiosResponse } from "axios";

interface ILoginData {
  email: string;
  password: string;
}

Component.registerHooks(["beforeRouteEnter", "destroyed"]);

@Component({
  components: {
    PartnerModal
  }
})
export default class Login extends Mixins(FormErrorsMixin) {
  private email = "";
  private password = "";
  private loggingIn = false;
  private partners: Array<IPartner> = [];
  private showPartnerModal = false;
  public validatedInputs: Array<string> = ["email", "password"];

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.setLoginBackgroundColor();
      vm.getUsers();
    });
  }

  private login(): void {
    if (this.loggingIn) {
      return;
    }

    this.resetErrors();
    this.loggingIn = true;

    Api()
      .get("/sanctum/csrf-cookie")
      .then(() => {
        Api()
          .post("/api/internal/v1/login", this.loginCredentials)
          .then((response: AxiosResponse) => {
            this.partners = response.data.data;
            if (this.partners.length > 1) {
              this.showPartnerModal = true;
            } else if (this.partners.length === 1) {
              localStorage.setItem("partnerId", `${this.partners[0].id}`);
              localStorage.setItem("partnerCode", `${this.partners[0].code}`);
              this.$router.push({
                name: "UsersOverview"
              });
            }
          })
          .catch((error: any) => {
            console.log(error.response.data.errors);
            this.storeErrors(error.response.data.errors);
          })
          .finally(() => {
            this.loggingIn = false;
          });
      });
  }

  private getUsers(): void {
    if (
      localStorage.getItem("partnerId") != "" &&
      localStorage.getItem("partnerId") != null
    ) {
      let responseCode = 401;

      Api()
        .get(
          "/api/internal/v1/partners/" +
            localStorage.getItem("partnerId") +
            "/users?page=1&search=",
          { params: { page: 1, search: "" } }
        )
        .then((response: AxiosResponse) => {
          responseCode = response.status;
        })
        .catch((error: any) => {
          responseCode = error.status;
        })
        .finally(() => {
          if (responseCode == 200) {
            this.$router.push({
              name: "UsersOverview"
            });
          }
        });
    }
  }

  private setLoginBackgroundColor(): void {
    const el = document.body;
    el.classList.remove("bg-color");
    el.classList.add("bg-color-login");
  }

  private setDefaultBackgroundColor(): void {
    const el = document.body;
    el.classList.add("bg-color");
    el.classList.remove("bg-color-login");
  }

  get loginCredentials(): ILoginData {
    return {
      email: this.email,
      password: this.password
    };
  }

  private destroyed(): void {
    this.setDefaultBackgroundColor();
  }
}
